// Feltételezett elérési út: pl. src/pages/contacts.js vagy src/components/contacts.js
import React from 'react';

// Ha a fájl neve contacts.js, a komponens neve lehet pl. Contacts, ContactPage, vagy magyarul KapcsolatOldal
const KapcsolatOldal = () => {
  const pageStyle = {
    padding: '2rem',
    fontFamily: 'Arial, sans-serif',
    maxWidth: '800px',
    margin: '2rem auto', // Oldal középre igazítása és térköz felül/alul
    backgroundColor: '#f9f9f9', // Világos háttérszín az olvashatóságért
    borderRadius: '8px', // Lekerekített sarkok
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)', // Finom árnyék
    color: '#333' // Sötétebb alapszövegszín
  };

  const headingStyle = {
    color: '#b30000', // A navbarhoz illeszkedő vörös szín
    borderBottom: '2px solid #b30000',
    paddingBottom: '0.5rem',
    marginBottom: '1.5rem',
    textAlign: 'center' // Címsor középre
  };

  const contactItemStyle = {
    display: 'flex', // Flexbox az ikon és a szöveg egymás mellé igazításához
    alignItems: 'center', // Vertikális középre igazítás a flex konténeren belül
    marginBottom: '1.5rem', // Térköz az elemek között
    fontSize: '1.1rem', // Kicsit nagyobb betűméret
    lineHeight: '1.6'
  };

  const linkStyle = {
    color: '#b30000', // Link színe
    textDecoration: 'none',
    fontWeight: 'bold',
    marginLeft: '0.5rem' // Kis térköz a "Email:" vagy "Facebook:" után
  };

  const iconStyle = {
    marginRight: '12px', // Térköz az ikon és a szöveg között
    fontSize: '1.6rem', // Ikon mérete
    color: '#b30000', // Ikon színe (opcionális, lehet más is)
    minWidth: '30px', // Minimális szélesség, hogy az ikonok ne ugorjanak
    textAlign: 'center'
  };

  return (
    <div style={pageStyle}>
      <h1 style={headingStyle}>Kapcsolatfelvétel</h1>
      <p style={{ marginBottom: '2.5rem', fontSize: '1.1rem', lineHeight: '1.6', textAlign: 'center' }}>
        Ha kérdésed van, vagy szeretnél kapcsolatba lépni velünk, az alábbi elérhetőségeken teheted meg:
      </p>

      <div style={contactItemStyle}>
        {/* Egyszerű emoji ikonok. Profibb megoldás lehetne egy ikon könyvtár, pl. React Icons. */}
        <span style={iconStyle} role="img" aria-label="Email ikon">📧</span>
        <div>
          <strong>Email:</strong>
          <a href="mailto:robert.marki@live.com" style={linkStyle}>robert.marki@live.com</a>
        </div>
      </div>

      <div style={contactItemStyle}>
        <span style={iconStyle} role="img" aria-label="Facebook ikon">📘</span>
        <div>
          <strong>Facebook:</strong>
          <a href="https://www.facebook.com/profile.php?id=61580003427158" target="_blank" rel="noopener noreferrer" style={linkStyle}>
            Archery Nexus a Facebookon
          </a>
        </div>
      </div>

      {/* Egyéb opcionális elérhetőségek vagy üzenet */}
      {/* 
      <div style={contactItemStyle}>
        <span style={iconStyle} role="img" aria-label="Instagram ikon">📸</span>
        <div>
          <strong>Instagram:</strong>
          <a href="https://instagram.com/profilod" target="_blank" rel="noopener noreferrer" style={linkStyle}>
            Kövess Instagramon
          </a>
        </div>
      </div>
      */}

      <p style={{ marginTop: '3rem', fontSize: '1rem', fontStyle: 'italic', textAlign: 'center', color: '#555' }}>
        Minden megkeresésre igyekszünk a lehető leghamarabb válaszolni. Köszönjük türelmed!
      </p>
    </div>
  );
};

// Fontos: Győződj meg róla, hogy a komponens neve (itt KapcsolatOldal) megegyezik azzal,
// ahogyan importálni fogod a router konfigurációdban.
export default KapcsolatOldal;
